import { Link } from "wouter";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-dvh flex items-center justify-center bg-background p-8">
      <div className="text-center space-y-4">
        <h1 className="text-5xl font-display uppercase tracking-tight">404</h1>
        <p className="text-muted-foreground">That page rolled off the board.</p>
        <Button asChild>
          <Link href="/">Home</Link>
        </Button>
      </div>
    </div>
  );
}
